// src/features/gamesReducer.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { envBool } from "../utils/misc";

const isDevMode: boolean = envBool(import.meta.env.VITE_ENV_DEV_MODE);


export interface UserState {
    // Authentication
    isAuthenticated: boolean;
    cognitoSub: string | null;
    email: string | null;

    // User identity
    UserState: number;
    playerFirstName: string;
    playerLastName: string;
    profileImageUrl: string | null;
    provider: string;
    createdAt: number | null;
    lastProfileUpdate: number | null;

    // Financial
    bankAccounts: string[];

    // Permissions & UI
    isMoveModeActive: boolean;
    editPermsString: string;
    deleteRoommatePermsString: string;
    alarmLevel: number;
}

const initialState: UserState = isDevMode ? {
    // Auth
    isAuthenticated: false,
    cognitoSub: null,
    email: null,

    // User identity
    UserState: 1,
    playerFirstName: "",
    playerLastName: "",
    profileImageUrl: null,
    provider: "email",
    createdAt: null,
    lastProfileUpdate: null,

    // Financial
    bankAccounts: [
        "23051",
        "21589",
    ],

    // UI
    isMoveModeActive: true,
    editPermsString: "",
    deleteRoommatePermsString: "",
    alarmLevel: 3,
} : {
    // Auth
    isAuthenticated: false,
    cognitoSub: null,
    email: null,

    // User identity
    UserState: 1,
    playerFirstName: "",
    playerLastName: "",
    profileImageUrl: null,
    provider: "email",
    createdAt: null,
    lastProfileUpdate: null,

    // Financial
    bankAccounts: [],

    // UI
    isMoveModeActive: false,
    editPermsString: "",
    deleteRoommatePermsString: "",
    alarmLevel: 0,
};

const userReducer = createSlice({
    name: "userReducer",
    initialState,
    reducers: {
        /**
         * Sets The Current Player Data
         * @object {object} currentMinigame - the object that holds the player data
         */
        SET_PLAYERDATA: (state, action: PayloadAction<Partial<UserState>>) => {
            //console.log("SETTING PLAYER DATA", action.payload);
            return {...state, ...action.payload};
        },
        /**
         * Set authentication state
         */
        SET_AUTH_USER: (state, action: PayloadAction<{
            cognitoSub: string;
            email: string;
            UserState: number;
            playerFirstName: string;
            playerLastName: string;
        }>) => {
            state.isAuthenticated = true;
            state.cognitoSub = action.payload.cognitoSub;
            state.email = action.payload.email;
            state.UserState = action.payload.UserState;
            state.playerFirstName = action.payload.playerFirstName;
            state.playerLastName = action.payload.playerLastName;
        },
        /**
         * Clear auth on logout
         */
        CLEAR_AUTH_USER: (state) => {
            state.isAuthenticated = false;
            state.cognitoSub = null;
            state.email = null;
            state.playerFirstName = "";
            state.playerLastName = "";
        },
    },
});

export const { SET_PLAYERDATA, SET_AUTH_USER, CLEAR_AUTH_USER } = userReducer.actions;
export default userReducer.reducer;
